import { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from 'react-router-dom';
import { useAuth } from "../login/AuthProvider";
import { member, member_page, member_count, file_upload } from '../../components/apipath';
import SwitchBox from "../../components/switchBox";
import {switchHelper, dateHelper} from "../../modules/helpers";
import PageList from "../../components/pageList";

function AdmMember() {
    const [memberlist, setMemberlist] = useState([]);
    const [editingMember, setEditingMember] = useState(null);
    const [updatedData, setUpdatedData] = useState({});
    const [rowsCount, setRowsCount] = useState(1); // 暫存資料總筆數
    const [newMember, setNewMember] = useState(null); // 用於保存新行的數據
    const [loading, setLoading] = useState(true);
    const [formErrors, setFormErrors] = useState({});
    const navigate = useNavigate();
    const { token } = useAuth();
    const memberStatus = [
        { label: '在職者', value: 'incumbent' },
        { label: '在學生', value: 'student' },
        { label: '全職考生', value: 'candidates' },
        { label: '待業中', value: 'unemployed' }
      ];
    const userType = ['請選擇', 'CPA', 'CMA'];


    //Read 將後端 mem 所有學生資訊導入
    const fetchData = async (page=1, rows=50) => {
        try {
            setLoading(true); // 開始加載
            const response = await axios.get(`${member_page(page-1, rows)}`, {headers:{token: token}});
            setMemberlist(response.data);
            setLoading(false); // 完成加載
        } catch (error) {
            console.error('Error:', error);
            setLoading(false);
        }
    };

    const fetchPageData = async () => {
        try {
            const response = await axios.get(`${member_count}`, {headers:{token: token}});
            setRowsCount(response.data[0].total);  
        } catch (error) {
            console.error('Error:', error);
        }
    }

    useEffect(() => {
        fetchData();
    }, []);

    useEffect(() => {
        fetchPageData();
    }, []);
    
    const validateForm = (data) => {
        const errors = {};
        if (!data) {
            errors.general = "資料錯誤，請重新整理頁面";
            return errors;
        }
    
        if (!data.chinese_name?.trim()) errors.chinese_name = "中文姓名為必填";
        if (!data.account?.trim()) errors.account = "帳號為必填";
        if (!data.password?.trim() || data.password.length < 6) errors.password = "密碼至少 6 碼";
        if (!data.user_type) errors.user_type = "請選擇用戶類別";
        if (!data.phone_num?.trim()) errors.phone_num = "電話為必填";
        if (!/^\d{10,}$/.test(data.phone_num)) errors.phone_num = "電話格式錯誤，需為至少10碼數字";
        if (!data.email?.trim()) errors.email = "Email為必填";
        if (!/\S+@\S+\.\S+/.test(data.email)) errors.email = "Email 格式錯誤";
        if (!data.address?.trim()) errors.address = "地址為必填";
    
        return errors;
    };


    //Update 設定編輯狀態
    const startEditing = (member) => {
        setEditingMember(member);
        setUpdatedData(member);
    };
    const handleInputChange = (e) => {
        const { name, value, checked, type } = e.target;
        if (['checkbox'].includes(type)){
            setUpdatedData({
                mem_id: editingMember.mem_id,
                ...updatedData,
                [name]: switchHelper(checked),
            });
        } else {
            setUpdatedData({
                mem_id: editingMember.mem_id,
                ...updatedData,
                [name]: value,
            });
        }
    };

    const saveChanges = async () => {
        const errors = validateForm(updatedData);
        if (Object.keys(errors).length > 0) {
            setFormErrors(errors);
            return;
        }
        setFormErrors({});

        if (
            updatedData.password === editingMember.password || // 舊密碼未變
            !updatedData.password?.trim()                     // 或密碼是空的
        ) {
            delete updatedData.password; // 不傳給後端
        }
        try {
            await axios.put(`${member}`, updatedData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    token: token
                }
            });
            const updatedMemberList = memberlist.map(member => {
                if (member.mem_id === editingMember.mem_id) {
                    return updatedData;
                }
                return member;
            });
            setMemberlist(updatedMemberList);
            setEditingMember(null);
        } catch (error) {
            console.error('Error updating member:', error);
        }
    };

    // Create 點擊新增按鈕時的處理函數
    const handleAddNew = () => {
        setNewMember({
            chinese_name: '',
            account: '',
            password: '',
            first_name: '',
            last_name: '',
            purchase_date: '',
            auth: '',
            comment: '',
            active_date: '',
            user_type: '',
            id_num: '',
            phone_num: '',
            email: '',
            address: '',
            status: '',
            school: '',
            major: '',
            grade: '',
            industry: '',
            company_name: '',
            info_way: '',
            createdate: '',
            pass: 0,
            postpone: 0,
            refund: 0,
            total_points: 0,
            account_status: 1,
            mem_status: 1,
        });
    };

    // Create 處理新行輸入的變化
    const handleNewInputChange = (e) => {
        const { name, value, checked, type } = e.target;
        
        if (['checkbox'].includes(type)){
            setNewMember({
                ...newMember,
                [name]: switchHelper(checked),
            });
        } else {
            setNewMember({
                ...newMember,
                [name]: value,
            });
        }
    };

    // Create 保存新行
    const handleSaveNew = async () => {
        const errors = validateForm(newMember);
        if (Object.keys(errors).length > 0) {
            setFormErrors(errors);
            return; // 阻止送出
        }
        setFormErrors({});
        if (!updatedData.password?.trim()) {
            delete updatedData.password;
        }
        try {
            // 發送 POST 請求將新學生數據保存到後端
            const response = await axios.post(`${member}`, newMember, {headers:{Authorization: `Bearer ${token}`,
                token: token}});
            if (response.data.status === 200){
                // 新增成功，顯示成功通知
                alert('新增成功！');
                // 將新的學生數據添加到 memberlist 狀態中
                let newData = newMember;
                newData.mem_id = response.data.data[0].insertId;
                setMemberlist([...memberlist, newData]);
                // 重置 newMember 狀態
                setNewMember(null);
                // 跳轉到另一個頁面（例如學生列表頁）
                //navigate('/adm/admmember'); // 請根據您的路由結構指定正確的路徑
            } else {
                console.error('Error saving new member:', response.data.msg);
            }
            
        } catch (error) {
            console.error('Error saving new member:', error);
        }
    };


    return (
        <>  
            <div className="container mt100">
                <div className="text-end mt-2">
                    <button className="btn btn-success me-2" onClick={handleAddNew}>新增</button>
                </div>
                <div className="mt-2 table-responsive">
                    <table className="table table-striped border table-hover">
                        <thead>
                            <tr>
                                <th scope="col">姓名</th>
                                <th scope="col">狀態</th>
                                <th scope="col">帳號</th>
                                <th scope="col">手機</th>
                                <th scope="col">信箱</th>
                                <th scope="col">創建日期</th>
                                <th scope="col">功能</th>
                                <th scope="col">編輯</th>
                            </tr>
                        </thead>
                        <tbody>
                            {/* 渲染新行 */}
                            {newMember && (
                                <tr>
                                    <td colSpan={7}>
                                        <div className="container">
                                            <div className="row g-1">
                                                <div className="col-xl-3 col-md-4 col-sm-6 col-12">
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text"><i className="fa-solid fa-star text-danger me-1"></i>中文姓名</span>
                                                        <input
                                                            className={`form-control form-control-sm ${formErrors.chinese_name ? 'is-invalid' : ''}`}
                                                            type="text"
                                                            name="chinese_name"
                                                            value={newMember.chinese_name}
                                                            onChange={handleNewInputChange}
                                                            required // 必填
                                                        />
                                                        {formErrors.chinese_nameame && (
                                                            <div className="invalid-feedback">
                                                                {formErrors.chinese_name}
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="col-xl-3 col-md-4 col-sm-6 col-12">
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text"><i className="fa-solid fa-star text-danger me-1"></i>帳號</span>
                                                        <input
                                                            className={`form-control form-control-sm ${formErrors.account ? 'is-invalid' : ''}`}
                                                            type="text"
                                                            name="account"
                                                            value={newMember.account}
                                                            onChange={handleNewInputChange}
                                                            required // 必填
                                                        />
                                                        {formErrors.account && (
                                                            <div className="invalid-feedback">
                                                                {formErrors.account}
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="col-xl-3 col-md-4 col-sm-6 col-12">
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text"><i className="fa-solid fa-star text-danger me-1"></i>密碼</span>
                                                        <input
                                                            className={`form-control form-control-sm ${formErrors.password ? 'is-invalid' : ''}`}
                                                            type="password"
                                                            name="password"
                                                            value={newMember.password}
                                                            onChange={handleNewInputChange}
                                                            required // 必填
                                                        />
                                                        {formErrors.password && (
                                                            <div className="invalid-feedback">
                                                                {formErrors.password}
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="col-xl-3 col-md-4 col-sm-6 col-12">
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text">英文名字</span>
                                                        <input
                                                            className="form-control form-control-sm"
                                                            type="text"
                                                            name="first_name"
                                                            value={newMember.first_name}
                                                            onChange={handleNewInputChange}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-xl-3 col-md-4 col-sm-6 col-12">
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text">英文姓氏</span>
                                                        <input
                                                            className="form-control form-control-sm"
                                                            type="text"
                                                            name="last_name"
                                                            value={newMember.last_name}
                                                            onChange={handleNewInputChange}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-xl-3 col-md-4 col-sm-6 col-12">
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text">購買日期</span>
                                                        <input
                                                            className="form-control form-control-sm"
                                                            type="date"
                                                            name="purchase_date"
                                                            value={dateHelper(newMember.purchase_date, "date")}
                                                            onChange={handleNewInputChange}
                                                        />
                                                    </div>
                                                </div>
                                                {/* <div className="col-xl-3 col-md-4 col-sm-6 col-12">
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text">權限</span>
                                                        <input
                                                            className="form-control form-control-sm"
                                                            type="text"
                                                            name="auth"
                                                            value={newMember.auth}
                                                            onChange={handleNewInputChange}
                                                        />
                                                    </div>
                                                </div> */}
                                                <div className="col-xl-3 col-md-4 col-sm-6 col-12">
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text"><i className="fa-solid fa-star text-danger me-1"></i>用戶類別</span>
                                                        <select
                                                            className={`form-control form-control-sm ${formErrors.user_type ? 'is-invalid' : ''}`}
                                                            name="user_type"
                                                            value={newMember.user_type}
                                                            onChange={handleNewInputChange}
                                                            required
                                                        >
                                                            {userType.map((value, index)=>{
                                                                if (index === 0) return <option key={value} value={''}>{value}</option>
                                                                return <option key={value} value={value}>{value}</option>;
                                                            })}
                                                        </select>
                                                        {formErrors.user_type && (
                                                            <div className="invalid-feedback">
                                                                {formErrors.user_type}
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="col-xl-3 col-md-4 col-sm-6 col-12">
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text">證件號碼</span>
                                                        <input
                                                            className="form-control form-control-sm"
                                                            type="text"
                                                            name="id_num"
                                                            value={newMember.id_num}
                                                            onChange={handleNewInputChange}
                                                            required // 必填
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-xl-3 col-md-4 col-sm-6 col-12">
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text"><i className="fa-solid fa-star text-danger me-1"></i>聯絡電話</span>
                                                        <input
                                                            className={`form-control form-control-sm ${formErrors.phone_num ? 'is-invalid' : ''}`}
                                                            type="text"
                                                            name="phone_num"
                                                            value={newMember.phone_num}
                                                            onChange={handleNewInputChange}
                                                            required // 必填
                                                        />
                                                        {formErrors.phone_num && (
                                                            <div className="invalid-feedback">
                                                                {formErrors.phone_num}
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="col-xl-3 col-md-4 col-sm-6 col-12">
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text"><i className="fa-solid fa-star text-danger me-1"></i>Email</span>
                                                        <input
                                                            className={`form-control form-control-sm ${formErrors.email ? 'is-invalid' : ''}`}
                                                            type="email"
                                                            name="email"
                                                            value={newMember.email}
                                                            onChange={handleNewInputChange}
                                                            required // 必填
                                                        />
                                                        {formErrors.email && (
                                                            <div className="invalid-feedback">
                                                                {formErrors.email}
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="col-xl-3 col-md-4 col-sm-6 col-12">
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text"><i className="fa-solid fa-star text-danger me-1"></i>學員狀態</span>
                                                        <select
                                                            className="form-select form-select-sm"
                                                            onChange={handleNewInputChange}
                                                            name="status"
                                                            value={newMember.status}
                                                            required
                                                            >
                                                            <option value="">請選擇</option>
                                                            {memberStatus.map((item) => (
                                                                <option key={item.value} value={item.value}>{item.label}</option>
                                                            ))}
                                                        </select>
                                                        
                                                    </div>
                                                </div>
                                                <div className="col-12">
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text"><i className="fa-solid fa-star text-danger me-1"></i>地址</span>
                                                        <input
                                                            className={`form-control form-control-sm ${formErrors.address ? 'is-invalid' : ''}`}
                                                            type="text"
                                                            name="address"
                                                            value={newMember.address}
                                                            onChange={handleNewInputChange}
                                                            required // 必填
                                                        />
                                                        {formErrors.address && (
                                                            <div className="invalid-feedback">
                                                                {formErrors.address}
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="col-xl-3 col-md-4 col-sm-6 col-12">
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text">學校</span>
                                                        <input
                                                            className="form-control form-control-sm"
                                                            type="text"
                                                            name="school"
                                                            value={newMember.school}
                                                            onChange={handleNewInputChange}
                                                            required // 必填
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-xl-3 col-md-4 col-sm-6 col-12">
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text">專業</span>
                                                        <input
                                                            className="form-control form-control-sm"
                                                            type="text"
                                                            name="major"
                                                            value={newMember.major}
                                                            onChange={handleNewInputChange}
                                                            required // 必填
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-xl-3 col-md-4 col-sm-6 col-12">
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text">年級</span>
                                                        <input
                                                            className="form-control form-control-sm"
                                                            type="text"
                                                            name="grade"
                                                            value={newMember.grade}
                                                            onChange={handleNewInputChange}
                                                            required // 必填
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-xl-3 col-md-4 col-sm-6 col-12">
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text">產業</span>
                                                        <input
                                                            className="form-control form-control-sm"
                                                            type="text"
                                                            name="industry"
                                                            value={newMember.industry}
                                                            onChange={handleNewInputChange}
                                                            required // 必填
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-xl-3 col-md-4 col-sm-6 col-12">
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text">公司</span>
                                                        <input
                                                            className="form-control form-control-sm"
                                                            type="text"
                                                            name="company_name"
                                                            value={newMember.company_name}
                                                            onChange={handleNewInputChange}
                                                            required // 必填
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-xl-3 col-md-4 col-sm-6 col-12">
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text">如何得知Becker</span>
                                                        <input
                                                            className="form-control form-control-sm"
                                                            type="text"
                                                            name="info_way"
                                                            value={newMember.info_way}
                                                            onChange={handleNewInputChange}
                                                            required // 必填
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-xl-3 col-md-4 col-sm-6 col-12">
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text">啟用日期</span>
                                                        <input
                                                            className="form-control form-control-sm"
                                                            type="date"
                                                            name="active_date"
                                                            value={dateHelper(newMember.active_date, "date")}
                                                            onChange={handleNewInputChange}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-xl-3 col-md-4 col-sm-6 col-12">
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text">數位點數</span>
                                                        <input
                                                            className="form-control form-control-sm"
                                                            type="number"
                                                            name="total_points"
                                                            value={(newMember.total_points)}
                                                            onChange={handleNewInputChange}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-12">
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text">備註</span>
                                                        <input
                                                            className="form-control form-control-sm"
                                                            type="textarea"
                                                            name="comment"
                                                            multiple
                                                            value={newMember.comment}
                                                            onChange={handleNewInputChange}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-xl-3 col-md-4 col-sm-6 col-12">
                                                    <div className="input-group input-group-sm">
                                                        {SwitchBox('pass', newMember.pass, handleNewInputChange, "已通過")}
                                                    </div>
                                                </div>
                                                <div className="col-xl-3 col-md-4 col-sm-6 col-12">
                                                    <div className="input-group input-group-sm">
                                                        {SwitchBox('postpone', newMember.postpone, handleNewInputChange, "展延")}
                                                    </div>
                                                    {switchHelper(newMember.postpone) ? (
                                                        <div className="text-muted">
                                                            <input type="date" defaultValue={dateHelper(newMember.postpone_date, 'date')} name="postpone_date" onChange={handleNewInputChange}/>
                                                        </div>
                                                    ) : ""}
                                                </div>
                                                <div className="col-xl-3 col-md-4 col-sm-6 col-12">
                                                    <div className="input-group input-group-sm">
                                                        {SwitchBox('refund', newMember.refund, handleNewInputChange, "已退費")}
                                                    </div>
                                                </div>
                                                <div className="col-xl-3 col-md-4 col-sm-6 col-12">
                                                    <div className="input-group input-group-sm">
                                                        {SwitchBox('mem_status', newMember.mem_status, handleNewInputChange, "學員")}
                                                    </div>
                                                </div>
                                                <div className="col-xl-3 col-md-4 col-sm-6 col-12">
                                                    <div className="input-group input-group-sm">
                                                        {SwitchBox('account_status', newMember.account_status, handleNewInputChange, "帳戶狀態")}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        {/* 保存和取消按鈕 */}
                                        <button
                                            className="btn btn-primary m-1"
                                            onClick={handleSaveNew}
                                        >
                                            保存
                                        </button>
                                        <button
                                            className="btn btn-secondary m-1"
                                            onClick={() => setNewMember(null)}
                                        >
                                            取消
                                        </button>
                                    </td>
                                </tr>
                            )}
                            {memberlist.map((member) => (
                                <tr key={member.mem_id}>
                                    {editingMember && editingMember.mem_id === member.mem_id ? (
                                        <>
                                            <td colSpan={7}>
                                                <div className="container">
                                                    <div className="row g-1">
                                                        <div className="col-xl-3 col-md-4 col-sm-6 col-12">
                                                            <div className="input-group input-group-sm">
                                                                <span className="input-group-text"><i className="fa-solid fa-star text-danger me-1"></i>中文姓名</span>
                                                                <input
                                                                    className={`form-control form-control-sm ${formErrors.chinese_name ? 'is-invalid' : ''}`}
                                                                    type="text"
                                                                    name="chinese_name"
                                                                    value={updatedData.chinese_name}
                                                                    onChange={handleInputChange}
                                                                    required // 必填
                                                                />
                                                                {formErrors.chinese_name && (
                                                                    <div className="invalid-feedback">
                                                                        {formErrors.chinese_name}
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                        <div className="col-xl-3 col-md-4 col-sm-6 col-12">
                                                            <div className="input-group input-group-sm">
                                                                <span className="input-group-text"><i className="fa-solid fa-star text-danger me-1"></i>帳號</span>
                                                                <input
                                                                    className={`form-control form-control-sm ${formErrors.account ? 'is-invalid' : ''}`}
                                                                    type="text"
                                                                    name="account"
                                                                    value={updatedData.account}
                                                                    onChange={handleInputChange}
                                                                    required // 必填
                                                                />
                                                                {formErrors.account && (
                                                                    <div className="invalid-feedback">
                                                                        {formErrors.account}
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                        <div className="col-xl-3 col-md-4 col-sm-6 col-12">
                                                            <div className="input-group input-group-sm">
                                                                <span className="input-group-text"><i className="fa-solid fa-star text-danger me-1"></i>密碼</span>
                                                                <input
                                                                    className={`form-control form-control-sm ${formErrors.password ? 'is-invalid' : ''}`}
                                                                    type="password"
                                                                    name="password"
                                                                    value={updatedData.password}
                                                                    onChange={handleInputChange}
                                                                    required // 必填
                                                                />
                                                                {formErrors.password && (
                                                                    <div className="invalid-feedback">
                                                                        {formErrors.password}
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                        <div className="col-xl-3 col-md-4 col-sm-6 col-12">
                                                            <div className="input-group input-group-sm">
                                                                <span className="input-group-text">英文名字</span>
                                                                <input
                                                                    className="form-control form-control-sm"
                                                                    type="text"
                                                                    name="first_name"
                                                                    value={updatedData.first_name}
                                                                    onChange={handleInputChange}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-xl-3 col-md-4 col-sm-6 col-12">
                                                            <div className="input-group input-group-sm">
                                                                <span className="input-group-text">英文姓氏</span>
                                                                <input
                                                                    className="form-control form-control-sm"
                                                                    type="text"
                                                                    name="last_name"
                                                                    value={updatedData.last_name}
                                                                    onChange={handleInputChange}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-xl-3 col-md-4 col-sm-6 col-12">
                                                            <div className="input-group input-group-sm">
                                                                <span className="input-group-text">購買日期</span>
                                                                <input
                                                                    className="form-control form-control-sm"
                                                                    type="date"
                                                                    name="purchase_date"
                                                                    value={dateHelper(updatedData.purchase_date, "date")}
                                                                    onChange={handleInputChange}
                                                                />
                                                            </div>
                                                        </div>
                                                        {/* <div className="col-xl-3 col-md-4 col-sm-6 col-12">
                                                            <div className="input-group input-group-sm">
                                                                <span className="input-group-text">權限</span>
                                                                <input
                                                                    className="form-control form-control-sm"
                                                                    type="text"
                                                                    name="auth"
                                                                    value={updatedData.auth}
                                                                    onChange={handleInputChange}
                                                                />
                                                            </div>
                                                        </div> */}
                                                        <div className="col-xl-3 col-md-4 col-sm-6 col-12">
                                                            <div className="input-group input-group-sm">
                                                                <span className="input-group-text"><i className="fa-solid fa-star text-danger me-1"></i>用戶類別</span>
                                                                <select
                                                                    className={`form-control form-control-sm ${formErrors.user_type ? 'is-invalid' : ''}`}
                                                                    name="user_type"
                                                                    onChange={handleNewInputChange}
                                                                    value={updatedData.user_type}
                                                                    required
                                                                >
                                                                    {userType.map((value, index)=>{
                                                                        if (index === 0) return <option key={value} value={''}>{value}</option>
                                                                        return <option key={value} value={value}>{value}</option>;
                                                                    })}
                                                                </select>
                                                                {formErrors.user_type && (
                                                                    <div className="invalid-feedback">
                                                                        {formErrors.user_type}
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                        <div className="col-xl-3 col-md-4 col-sm-6 col-12">
                                                            <div className="input-group input-group-sm">
                                                                <span className="input-group-text"><i className="fa-solid fa-star text-danger me-1"></i>證件號碼</span>
                                                                <input
                                                                    className="form-control form-control-sm"
                                                                    type="text"
                                                                    name="id_num"
                                                                    value={updatedData.id_num}
                                                                    onChange={handleInputChange}
                                                                    required // 必填
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-xl-3 col-md-4 col-sm-6 col-12">
                                                            <div className="input-group input-group-sm">
                                                                <span className="input-group-text"><i className="fa-solid fa-star text-danger me-1"></i>聯絡電話</span>
                                                                <input
                                                                    className={`form-control form-control-sm ${formErrors.phone_num ? 'is-invalid' : ''}`}
                                                                    type="text"
                                                                    name="phone_num"
                                                                    value={updatedData.phone_num}
                                                                    onChange={handleInputChange}
                                                                    required // 必填
                                                                />
                                                                {formErrors.phone_num && (
                                                                    <div className="invalid-feedback">
                                                                        {formErrors.phone_num}
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                        <div className="col-xl-3 col-md-4 col-sm-6 col-12">
                                                            <div className="input-group input-group-sm">
                                                                <span className="input-group-text"><i className="fa-solid fa-star text-danger me-1"></i>Email</span>
                                                                <input
                                                                    className={`form-control form-control-sm ${formErrors.email ? 'is-invalid' : ''}`}
                                                                    type="email"
                                                                    name="email"
                                                                    value={updatedData.email}
                                                                    onChange={handleInputChange}
                                                                    required // 必填
                                                                />
                                                                {formErrors.email && (
                                                                    <div className="invalid-feedback">
                                                                        {formErrors.email}
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                        <div className="col-xl-3 col-md-4 col-sm-6 col-12">
                                                            <div className="input-group input-group-sm">
                                                                <span className="input-group-text"><i className="fa-solid fa-star text-danger me-1"></i>用戶狀態</span>
                                                                <select
                                                                    className="form-select form-select-sm"
                                                                    onChange={handleInputChange}
                                                                    name="status"
                                                                    value={updatedData.status}
                                                                    required
                                                                >
                                                                    {memberStatus.map((name, index)=>{
                                                                        return (<option key={name} value={index}>{name}</option>);
                                                                    })}
                                                                </select>
                                                                
                                                            </div>
                                                        </div>
                                                        <div className="col-12">
                                                            <div className="input-group input-group-sm">
                                                                <span className="input-group-text"><i className="fa-solid fa-star text-danger me-1"></i>地址</span>
                                                                <input
                                                                    className={`form-control form-control-sm ${formErrors.address ? 'is-invalid' : ''}`}
                                                                    type="text"
                                                                    name="address"
                                                                    value={updatedData.address}
                                                                    onChange={handleInputChange}
                                                                    required // 必填
                                                                />
                                                                {formErrors.address && (
                                                                    <div className="invalid-feedback">
                                                                        {formErrors.address}
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                        <div className="col-xl-3 col-md-4 col-sm-6 col-12">
                                                            <div className="input-group input-group-sm">
                                                                <span className="input-group-text">學校</span>
                                                                <input
                                                                    className="form-control form-control-sm"
                                                                    type="text"
                                                                    name="school"
                                                                    value={updatedData.school}
                                                                    onChange={handleInputChange}
                                                                    required // 必填
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-xl-3 col-md-4 col-sm-6 col-12">
                                                            <div className="input-group input-group-sm">
                                                                <span className="input-group-text">專業</span>
                                                                <input
                                                                    className="form-control form-control-sm"
                                                                    type="text"
                                                                    name="major"
                                                                    value={updatedData.major}
                                                                    onChange={handleInputChange}
                                                                    required // 必填
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-xl-3 col-md-4 col-sm-6 col-12">
                                                            <div className="input-group input-group-sm">
                                                                <span className="input-group-text">年級</span>
                                                                <input
                                                                    className="form-control form-control-sm"
                                                                    type="text"
                                                                    name="grade"
                                                                    value={updatedData.grade}
                                                                    onChange={handleInputChange}
                                                                    required // 必填
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-xl-3 col-md-4 col-sm-6 col-12">
                                                            <div className="input-group input-group-sm">
                                                                <span className="input-group-text">產業</span>
                                                                <input
                                                                    className="form-control form-control-sm"
                                                                    type="text"
                                                                    name="industry"
                                                                    value={updatedData.industry}
                                                                    onChange={handleInputChange}
                                                                    required // 必填
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-xl-3 col-md-4 col-sm-6 col-12">
                                                            <div className="input-group input-group-sm">
                                                                <span className="input-group-text">公司</span>
                                                                <input
                                                                    className="form-control form-control-sm"
                                                                    type="text"
                                                                    name="company_name"
                                                                    value={updatedData.company_name}
                                                                    onChange={handleInputChange}
                                                                    required // 必填
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-xl-3 col-md-4 col-sm-6 col-12">
                                                            <div className="input-group input-group-sm">
                                                                <span className="input-group-text">如何得知Becker</span>
                                                                <input
                                                                    className="form-control form-control-sm"
                                                                    type="text"
                                                                    name="info_way"
                                                                    value={updatedData.info_way}
                                                                    onChange={handleInputChange}
                                                                    required // 必填
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-xl-3 col-md-4 col-sm-6 col-12">
                                                            <div className="input-group input-group-sm">
                                                                <span className="input-group-text">啟用日期</span>
                                                                <input
                                                                    className="form-control form-control-sm"
                                                                    type="date"
                                                                    name="active_date"
                                                                    value={dateHelper(updatedData.active_date, "date")}
                                                                    onChange={handleInputChange}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-xl-3 col-md-4 col-sm-6 col-12">
                                                            <div className="input-group input-group-sm">
                                                                <span className="input-group-text">數位點數</span>
                                                                <input
                                                                    className="form-control form-control-sm"
                                                                    type="number"
                                                                    name="total_points"
                                                                    value={(updatedData.total_points)}
                                                                    onChange={handleInputChange}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-12">
                                                            <div className="input-group input-group-sm">
                                                                <span className="input-group-text">備註</span>
                                                                <input
                                                                    className="form-control form-control-sm"
                                                                    type="textarea"
                                                                    name="comment"
                                                                    multiple
                                                                    value={updatedData.comment}
                                                                    onChange={handleInputChange}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-xl-2 col-md-3 col-sm-6 col-12">
                                                            <div className="input-group input-group-sm">
                                                                {SwitchBox('pass', updatedData.pass, handleInputChange, "已通過")}
                                                            </div>
                                                        </div>
                                                        <div className="col-xl-2 col-md-3 col-sm-6 col-12">
                                                            <div className="input-group input-group-sm">
                                                                {SwitchBox('postpone', updatedData.postpone, handleInputChange, "展延")}
                                                            </div>
                                                            {switchHelper(updatedData.postpone) ? (
                                                                <div className="text-muted">
                                                                    <input type="date" defaultValue={dateHelper(updatedData.postpone_date, 'date')} name="postpone_date" onChange={handleInputChange}/>
                                                                </div>
                                                            ) : ""}
                                                        </div>
                                                        <div className="col-xl-2 col-md-3 col-sm-6 col-12">
                                                            <div className="input-group input-group-sm">
                                                                {SwitchBox('refund', updatedData.refund, handleInputChange, "已退費")}
                                                            </div>
                                                        </div>
                                                        <div className="col-xl-2 col-md-3 col-sm-6 col-12">
                                                            <div className="input-group input-group-sm">
                                                                {SwitchBox('mem_status', updatedData.mem_status, handleInputChange, "學員")}
                                                            </div>
                                                        </div>
                                                        <div className="col-xl-2 col-md-3 col-sm-6 col-12">
                                                            <div className="input-group input-group-sm">
                                                                {SwitchBox('account_status', updatedData.account_status, handleInputChange, "帳戶狀態")}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </td>
                                        </>
                                    ) : (
                                        <>
                                            <td>
                                                {member.chinese_name}
                                            </td>
                                            <td>
                                                {memberStatus[member.status]}
                                            </td>
                                            <td>
                                                {member.account}
                                            </td>
                                            <td>
                                                {member.phone_num}
                                            </td>
                                            <td>
                                                {member.email}
                                            </td>
                                            <td>
                                                {dateHelper(member.createtime, 'date')}
                                            </td>
                                            <td>
                                                <div>
                                                    <a href={`${file_upload}member/${member.mem_id}/mResume`} target="_blank" rel="noreferrer" className="btn btn-secondary btn-sm m-1 p-1">履歷</a>
                                                    <a href={`${file_upload}member/${member.mem_id}/mTranscript`} target="_blank" rel="noreferrer" className="btn btn-secondary btn-sm m-1 p-1">成績單</a>
                                                    <a href={`${file_upload}member/${member.mem_id}/mInterview`} target="_blank" rel="noreferrer" className="btn btn-secondary btn-sm m-1 p-1">諮詢紀錄</a>
                                                    <a href={`${file_upload}member/${member.mem_id}/mApplication`} target="_blank" rel="noreferrer" className="btn btn-secondary btn-sm m-1 p-1">報考文件</a>
                                                    <a href={`${file_upload}member/${member.mem_id}/mAcademic`} target="_blank" rel="noreferrer" className="btn btn-secondary btn-sm m-1 p-1">學歷認證</a>
                                                </div>
                                            </td>
                                        </>
                                    )}
                                    <td>
                                        {editingMember && editingMember.mem_id === member.mem_id ? (
                                            <>
                                                <button
                                                    className="btn btn-primary m-1"
                                                    onClick={saveChanges}
                                                >
                                                    保存
                                                </button>
                                                <button
                                                    className="btn btn-secondary m-1"
                                                    onClick={() => setEditingMember(null)}
                                                >
                                                    取消
                                                </button>
                                            </>
                                        ) : (
                                            <button
                                                className="btn btn-primary m-1"
                                                onClick={() => startEditing(member)}
                                            >
                                                編輯
                                            </button>
                                        )}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table> 
                    <div className="m-2 p-2">
                        {PageList(rowsCount, fetchData)}
                    </div>
                </div>
            </div>
        </>
    );
}
export default AdmMember;